import { BaseError } from "./BaseError";
import type { ErrorContext } from "../types/index";
import { AUTHENTICATION_ERROR_CODES } from "../constants/errorCodes";

export interface AuthenticationErrorOptions {
  message: string;
  context?: Partial<ErrorContext>;
  code?: string;
  cause?: Error;
}

/**
 * Error thrown when authentication fails
 */
export class AuthenticationError extends BaseError {
  constructor(options: AuthenticationErrorOptions) {
    super({
      message: options.message,
      category: "authentication",
      severity: "low",
      statusCode: 401,
      code: options.code ?? AUTHENTICATION_ERROR_CODES.AUTHENTICATION_ERROR,
      context: options.context,
      cause: options.cause,
      userVisible: true,
      reportable: true,
    });
  }
}
